import { useMemo } from 'react'

import { useWallet, Wallet } from 'use-wallet'

import useThunderHub from './useThunderHub'
import { config } from 'configs'

/// 這邊實際上都是 Wallet 的規格, 稍微簡化一點
export type ClientWallet = Wallet | {
  account?: string
  balance?: string
  chainId?: number
  ethereum?: any
  status?: string
  connect?: (method: 'injected' | 'walletconnect') => Promise<void>
}

/** 將 ThunderHub::Wallet / useWallet::Wallet 與 空物件 等合併成共用的 ClientWallet type */
export default function useClientWallet(): ClientWallet {
  const wallet = useWallet()
  const { isHub, hubData } = useThunderHub()

  return useMemo(
    () => {
      return isHub
        ? {
          ...wallet,
          account: hubData?.walletAddress ?? '',
          chainId: config('chain-id', 0),
          ethereum: window.ethereum,
          status: 'connected',
          // unused: connect, error, networkName, type
        }
        : wallet
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [wallet]
  )
}
